import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import ContentArea from '../../components/ContentArea'

const ListLink = styled(Link)`
  margin-top: 2rem;
`

const Home = () => {
    return (
        <ContentArea>
            {/* <h2>Department of Integrative Medicine and Nutritional Sciences at The Marcus Institute of Integrative Health, Thomas Jefferson University Hospital.</h2> */}
            <ListLink to={`/nutrition/dietary`}>Dietary Approach</ListLink>
            <ListLink to={`/nutrition/tips`}>Some Healthful Tips</ListLink>
            <ListLink to={`/nutrition/anti-inflammatory`}>Foods Included In An Anti-Inflammatory Diet</ListLink>
            <ListLink to={`/nutrition/snacks`}>Snacks</ListLink>
        </ContentArea>
    )
}

export default Home
